import React, { Component } from 'react';
import Modal from 'react-modal';
import InvoiceItemCreateModalUI from './InvoiceItemCreateModalUI';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import { withRouter } from 'react-router-dom';

class InvoiceItemCreateModalSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      quantity: '',
      quantityError: null,
      customerId: '',
      customerIdError: null,
      productItemId: '',
      productItemIdError: null,
      invoiceItemList: []
    };
  }


  render() {
    return (
      <InvoiceItemCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelCreate={this.onCancelCreate}
        selectedInvoice={this.props.selectedInvoice}

        quantity={this.state.quantity}
        onQuantityChange={(event) => this.setState({ quantity: event.target.value })}
        quantityError={this.state.quantityError}
        setQuantityError={(error) => this.setState({ quantityError: error })}

        productItemId={this.state.productItemId}
        onProductItemIdChange={(event) => this.setState({ productItemId: event.target.value })}
        productItemIdError={this.state.productItemIdError}
        setProductItemIdError={(error) => this.setState({ productItemIdError: error })}
        invoiceItemList={this.state.invoiceItemList}

      />
    );
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  componentDidUpdate(prevProps) {
    const { selectedInvoice } = this.props;
    if (selectedInvoice && (!prevProps.selectedInvoice || prevProps.selectedInvoice.customerInvoiceId !== selectedInvoice.customerInvoiceId)) {
      this.setState({
        customerId: selectedInvoice.customerId,
        invoiceItemList: selectedInvoice.invoiceItemList || []
      });
    }
  }

  onCancelCreate = () => {
    this.setState({
      submitted: false,
      errorList: null,
    });
    this.props.onCancelCreate();
  }

  onSubmit = () => {
    if (this.state.submitted) return;

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    });

    const { selectedInvoice } = this.props;

    if (selectedInvoice) {
      RestApiUtils.post(
        this.props.context,
        `/api/su/accounts/${this.props.account.accountId}/invoices/${selectedInvoice.customerInvoiceId}/invoiceItems`,
        this.onSubmitCallback,
        {
          productItemId: this.state.productItemId,
          quantity: this.state.quantity,

        }
      );
    } else {
      console.error("No selected invoice available for submission.");
      this.setState({
        submitted: false,
        errorList: ['No selected invoice available for submission.'],
      });
    }
  }

  onSubmitCallback = (response) => {
    let errorList = [];
    if (response.errorList) {
      errorList = response.errorList.map((error) => error.message);
    }

    this.setState({
      successMsg: response.success || null,
      errorList: errorList,
      submitted: false,
    });

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null,
        });
        this.props.onCancelCreate();
        this.props.onRefreshClick();
      }, 1000);
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList });
  }
}

export default withRouter(InvoiceItemCreateModalSF);
